import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { CommonHeader, ErrorSuccessModal } from "../../components/commons";

import InsightAdvancedList from "../../components/InsightAdvanced/Table/InsightAdvancedList";
import { resetSession } from "../../redux/auth";

import { UserIcon } from "../../components/Icon";
import { resetInsightAdvancedError } from "../../redux/insightsAdvanced";
import { RootState } from "../../redux/rootReducers";

type AppProps = {
  token: string | null;
  history: any;
  dispatchResetSession: () => void;
  statusCode: number | null;
  error: string | null;
  success: number | null;
  dispatchResetInsightAdvancedError: () => void;
};
interface TabsType {
  name: string;
  label: string;
}

const tabs: TabsType[] = [
  {
    name: "Sales",
    label: "sales",
  },
  {
    name: "Expense",
    label: "expenses",
  },
];
const InsightsAdvacedList = ({
  token,
  history,
  dispatchResetSession,
  statusCode,
  error,
  success,
  dispatchResetInsightAdvancedError,
}: AppProps) => {
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : null;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  let hash = history?.location?.hash?.replace(/[^\w\s]/gi, "");

  const finalTabFromPath = history?.location?.pathname?.split("#")[1];

  const activeUrlTab = hash ? hash : finalTabFromPath;
  const [activeTab, setActiveTab] = useState(activeUrlTab);
  useEffect(() => {
    dispatchResetInsightAdvancedError();
  }, []);
  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);

    const { location = {} } = history;

    history.push({
      ...location,
      search: "",
      hash: `#${tabs}`,
      pathname: `/insights-advanced-summary/profit-loss/${client_code}`,
    });
  };
  const renderTabs = () => {
    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className="tab-style mr-5 "
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          <div
            style={{ padding: "12px 5px 12px 5px" }}
            className={`tab-header ${activeTab === tab.label ? "active" : ""}`}
          >
            {tab.name}
          </div>
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInsightAdvancedError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader title="Profit & Loss Statement" />
          <div className="d-flex align-items-center">
            {client_code ? (
              <>
                <UserIcon /> &nbsp;
                {company_name} {"(" + client_code + ")"}
              </>
            ) : null}
          </div>
        </div>

        <div className="col-md-12">
          <div
            style={{
              background: "#d8dee4",
              borderRadius: "5px 5px 0 0",
              padding: "0px 15px 0px 15px",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{ justifyContent: "space-between" }}
            >
              <div className="d-flex">{renderTabs()}</div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div
            className="new-table-card p-3"
            style={{ borderTopRightRadius: "0px", borderTopLeftRadius: "0px" }}
          >
            <InsightAdvancedList
              client_code={client_code}
              activeTab={activeTab}
              history={history}
              company_name={company_name}
            />
          </div>
        </div>
        {handleErrorModal()}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.insightsAdvanced.error,
  statusCode: state.insightsAdvanced.statusCode,
  success: state.insightsAdvanced.success,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInsightAdvancedError: () =>
    dispatch(resetInsightAdvancedError()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsAdvacedList);
